































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import { Store } from 'vuex';
import CustomSelectInput from '../../components/vui-luma/Ui/CustomSelectInput.vue';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';
import {dispatchAddContact, dispatchGetContacts, dispatchUpdateContact} from '@/store/contacts/actions';
import mainFields, { additionalFields } from './fields';
import {IContact} from '@/interfaces';
import { Datetime } from 'vue-datetime';

@Component({
  components: {
    CustomSelectInput,
    MdIcon,
    Datetime,
  },
})
export default class AddContactModal extends Vue {
  @Prop({default: null}) public contact!: IContact;

  public addContactVisible = false;
  public additionalFieldsVisible = false;
  public mainFields = mainFields;
  public additionalFields = additionalFields;

  public resetAddForm() {
    this.addContactVisible = false;
    this.additionalFieldsVisible = false;
    // @ts-ignore
    this.$refs.addContactForm.reset();
    for (const [key, item] of Object.entries(mainFields)) {
      // @ts-ignore
      item.error = false;
    }
  }

  public async validateAddForm() {
    let isValid = true;

    for (const [key, item] of Object.entries(mainFields)) {
      // @ts-ignore
      if (item.required) {
        // @ts-ignore
        if (!document.getElementsByName(`${item.id}`)[0].value) {
          // @ts-ignore
          item.error = true;
          isValid = false;
        } else {
          // @ts-ignore
          item.error = false;
        }
      }
    }
    return isValid;
  }

  public async submitAddContact() {
    if (await this.validateAddForm()) {
      const formData = new FormData();
      // @ts-ignore
      const elements = this.$refs.addContactForm.elements;
      for (const [key, item] of Object.entries(elements)) {
        // @ts-ignore
        if (item.name !== undefined) {
          // @ts-ignore
          formData.append(item.name, item.value ? item.value : '');
        }
      }
      if (this.contact) {
        await dispatchUpdateContact(
          this.$store,
          {
            contactId: this.contact.id,
            data: formData,
          },
        );
      } else {
        await dispatchAddContact(
          this.$store,
          {
            data: formData,
          },
        );
      }
      this.resetAddForm();
    }
  }

}
